export default __webpack_public_path__ + "static/media/nodata.30539eef.gif";